import { Box } from '@mui/material';
import BaseLoadingIndicator from 'features/room/components/BaseLoadingIndicator';
import React from 'react';

export const WhiteboardLoader = () => (
  <Box
    sx={{
      backgroundColor: '#fff',
      display: 'flex',
      width: 'calc(100%)',
      height: 'calc(100%)',
      left: '0',
      top: '0',
      alignItems: 'center',
      justifyContent: 'center',
      borderRadius: '8px',
      position: 'absolute',
      zIndex: 1000,
    }}
  >
    <BaseLoadingIndicator />
  </Box>
);
